import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { theme, colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import {
  size,
  lineHeight,
  weight,
  fontFamilySans,
} from "@clockwise/web-commons/src/styles/type.styles";
import { baseBody } from "../SuggestionBody.styles";

const body: CSSProperties = {
  ...baseBody,
  width: "100%",
  backgroundColor: greys.white,
};

const heading: CSSProperties = {
  fontSize: "12px",
  paddingBottom: 0,
};

export const activity = {
  body: {
    margin: "15px 0 10px 0",
    fontSize: size.std,
    lineHeight: lineHeight.std,
    color: greys.slate,
  } as CSSProperties,
  row: {
    display: "flex",
    alignItems: "baseline",
  } as CSSProperties,
  stat: {
    color: colors.green.darker,
    marginRight: 10,
    fontSize: 22,
    paddingLeft: 10,
    minWidth: 60,
    textAlign: "right",
  } as CSSProperties,
};

const footer: CSSProperties = {
  fontSize: 12,
  padding: "20px 10px 15px 10px",
  borderTop: `1px solid ${greys.borderGrey}`,
};

const actions: CSSProperties = {
  display: "flex",
  paddingTop: 10,
};

const actionButton: CSSProperties = {
  minWidth: "55px",
  borderRadius: 20,
  marginRight: 7,
};

const unselectedActionButton: CSSProperties = {
  ...actionButton,
  backgroundColor: greys.paleGrey,
};

const selectedActionButton = {
  ...actionButton,
  backgroundColor: greys.cloudyBlue,
};

const actionLabel: CSSProperties = {
  borderRadius: 0,
  fontSize: 12,
  color: theme.textSecondary,
  textTransform: "uppercase",
  fontWeight: weight.bold,
};

const feedback: CSSProperties = {
  fontFamily: fontFamilySans,
  color: greys.slate,
};

export const styles = {
  body,
  heading,
  footer,
  actions,
  unselectedActionButton,
  selectedActionButton,
  actionLabel,
  feedback,
};
